export default __webpack_public_path__ + "static/media/background.57e652d9.png";